
import { priceFormat, priceFormatOther } from "@/utils/utils"

export default {
  name: "ProductSkuList",
  props: {
    skuId: {
      type: [Number, String],
      default: ""
    },
    skuList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      selectedSkuId: this.skuId
    }
  },
  methods: {
    priceFormat,
    priceFormatOther,
    handleSkuCard(item, index) {
      this.selectedSkuId = item.skuId
      this.$emit("change", item, index)
    }
  }
}
